import { queryOptions } from '@tanstack/react-query';

import { EQueryKeys } from '@enums/queryKeys.enum';
import { topicsImportFileSchema } from '@schemas/topicsImportFile.schema';
import { treatmentCreatesService } from '@services/treatmentCreates/service';
import type { GetTreatmentCreateByIdOutput } from '@services/treatmentCreates/types/getById.type';

import type { ContentEditorSettings } from './types';

export const treatmentCreateEditorSettings = {
  api: {
    createMessage: ({ demandId, message }) =>
      treatmentCreatesService.createMessage({
        message,
        treatmentCreateId: demandId,
      }),
    createTopic: ({ content, demandId, position, title }) =>
      treatmentCreatesService.createTopic({
        content,
        position,
        title,
        treatmentCreateId: demandId,
      }),
    importTopics: ({ demandId, file }) =>
      treatmentCreatesService.importTopics({
        file,
        treatmentCreateId: demandId,
      }),
    markReview: demandId => treatmentCreatesService.markReview(demandId),
    removeAllTopics: demandId =>
      treatmentCreatesService.removeAllTopics({ treatmentCreateId: demandId }),
    removeTopic: ({ demandId, id }) =>
      treatmentCreatesService.removeTopic({ id, treatmentCreateId: demandId }),
    reorderTopics: ({ demandId, ids }) =>
      treatmentCreatesService.reorderTopics({
        ids,
        treatmentCreateId: demandId,
      }),
    updateMessage: ({ demandId, message, messageId }) =>
      treatmentCreatesService.updateMessage({
        message,
        treatmentCreateId: demandId,
        treatmentCreateMessageId: messageId,
      }),
    updateTopic: ({ content, demandId, id, title }) =>
      treatmentCreatesService.updateTopic({
        content,
        id,
        title,
        treatmentCreateId: demandId,
      }),
  },
  detailsQueryOptions: (id: string) =>
    queryOptions({
      queryKey: [EQueryKeys.NewTreatmentDetails, id],
      queryFn: () => treatmentCreatesService.getById(id),
      select: data => data.treatment,
      staleTime: 1000 * 60,
      refetchOnWindowFocus: false,
    }),
  import: {
    fileSchema: topicsImportFileSchema,
  },
  labels: {
    noun: 'protocolo',
    title: 'Detalhes do protocolo',
  },
  listPath: '/my-treatments',
  page: '/new-treatments',
  refreshDetails: queryClient =>
    queryClient.refetchQueries({
      queryKey: [EQueryKeys.NewTreatmentDetails],
    }),
  reviewQueryKeys: [
    [EQueryKeys.NewTreatmentDetails],
    [EQueryKeys.MyTreatmentUpdates],
    [EQueryKeys.MyTreatmentCreates],
    [EQueryKeys.NewTreatments],
  ],
} satisfies ContentEditorSettings<GetTreatmentCreateByIdOutput>;
